import React, { useState, useEffect } from 'react';
import HomeIcon from '@images/tournamentQuests/homeWhite.svg';
import AltitudeIcon from '@images/dashboard/altitude.svg';
import RankingMeter from '@images/dashboard/ranking_meter.svg';
import ProfilePic from '@images/profilePic.png';
import { xpleaderboard } from '@services/api';

const LeaderBoard = ({ setSelectedOption }) => {
    const Bucket_url = process.env.NEXT_PUBLIC_DELIEVERY_CONTENT_URL
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOptionLeaderBoard, setSelectedOptionLeaderBoard] = useState('Weekly');
    const [loading, setLoading] = useState(true);
    const [leaderBoardData, setLeaderBoardData] = useState([]);
    const [dateTime, setDateTime] = useState('');

    useEffect(() => {
        const formatDateTime = () => {
            const now = new Date();
            const weekday = now.toLocaleString('en-US', { weekday: 'short' });
            const day = now.getDate();
            const month = now.toLocaleString('en-US', { month: 'long' });
            let hour = now.getHours();
            const minute = now.getMinutes().toString().padStart(2, '0');
            const period = hour >= 12 ? 'PM' : 'AM';
            hour = hour % 12 || 12;
            const formattedDateTime = `Updated ${weekday} ${day}th ${month} ${hour}:${minute}${period}`;
            setDateTime(formattedDateTime);
        };

        formatDateTime();
    }, [selectedOptionLeaderBoard]);

    useEffect(() => {
        if (selectedOptionLeaderBoard) {
            xpleaderboardHandler(selectedOptionLeaderBoard);
        }
    }, [selectedOptionLeaderBoard]);

    const xpleaderboardHandler = async (option) => {
        setLoading(true);
        const response = await xpleaderboard(option.toLowerCase());
        if (response?.length > 0) {
            const sortedData = response.sort((a, b) => b.experience_points - a.experience_points);
            setLeaderBoardData(sortedData);
        }
        setLoading(false);
    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionClick = (option) => {
        setIsOpen(false);
        setLeaderBoardData([]);
        setSelectedOptionLeaderBoard(option);
    };

    const getStyleBg = (index) => {
        switch (index) {
            case 0:
                return {
                    borderRadius: '24px',
                    border: '1px solid #FFB648',
                    background: 'linear-gradient(270deg, rgba(255, 182, 72, 0.20) 0%, rgba(255, 182, 72, 0.00) 50%), #EFEFEF'
                };
            case 1:
                return {
                    borderRadius: '24px',
                    border: '1px solid #737373',
                    background: 'linear-gradient(270deg, rgba(115, 115, 115, 0.20) 0%, rgba(115, 115, 115, 0.00) 50%), #EFEFEF'
                };
            case 2:
                return {
                    borderRadius: '24px',
                    border: '1px solid #812F00',
                    background: 'linear-gradient(270deg, rgba(129, 47, 0, 0.20) 0%, rgba(129, 47, 0, 0.00) 50%), #EFEFEF'
                };
            default:
                return {
                    borderRadius: '24px',
                    border: '1px solid transparent',
                    background: '#EFEFEF'
                };
        }
    };

    const getStyleColor = (index) => {
        switch (index) {
            case 0:
                return {
                    background: '#FFB648'
                };
            case 1:
                return {
                    background: '#737373'
                };
            case 2:
                return {
                    background: '#812F00'
                };
            default:
                return {
                    background: '#FFF'
                };
        }
    };

    const getTextColor = (index) => {
        if (index === 1 || index === 2) {
            return '#FAFAFA';
        }
        return '#000';
    };

    return (
        <div className="relative top-[26px] h-screen w-screen overflow-auto bg-[#FAFAFA]">
            <div className="w-full flex flex-col gap-[36px] p-[36px]">
                <button
                    className="w-[215px] flex pl-[8px] pr-[12px] py-[6px] items-start gap-[6px] rounded-[1000px] bg-[#000]"
                    onClick={() => setSelectedOption(null)}
                >
                    <img
                        src={HomeIcon}
                        alt="home icon"
                        className="w-[20px] h-[20px]"
                    />
                    <p className="text-[#FAFAFA] text-[16px] not-italic font-bold leading-[normal] tracking-[-0.32px]">
                        Go back to dashboard
                    </p>
                </button>
                <div className="w-full flex flex-col items-center gap-[36px]">
                    <div className="w-[60%] flex justify-between items-center">
                        <p className="text-[#000] text-center text-[42px] not-italic font-semibold leading-[42px] tracking-[-2.52px]">
                            FrodoBots Leaderboard!
                        </p>
                        <div className="relative inline-block w-[194px] h-[32px]">
                            <div
                                className="w-full h-full flex px-[8px] py-[2px] justify-between items-center rounded-[8px] border-[1px] border-[solid] border-[#DEDEDE] bg-[#FFF] cursor-pointer"
                                onClick={toggleDropdown}
                            >
                                {selectedOptionLeaderBoard}
                                <span className={`ml-2 transform transition-transform ${isOpen ? 'rotate-180' : ''}`}>
                                    ▼
                                </span>
                            </div>
                            {isOpen && (
                                <div className="absolute left-0 right-0 mt-2 bg-white border border-gray-300 rounded-md shadow-lg z-10">
                                    <div
                                        className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                                        onClick={() => handleOptionClick('Weekly')}
                                    >
                                        Weekly
                                    </div>
                                    <div
                                        className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                                        onClick={() => handleOptionClick('Monthly')}
                                    >
                                        Monthly
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="w-full flex flex-col items-center gap-[2px]">
                        <div className='w-[60%] flex justify-end'>
                            <p className='text-[#000] text-[14px] not-italic font-medium leading-[25px] tracking-[-0.8px]'>{dateTime}</p>
                        </div>
                        <div className="w-[60%] flex h-[56px] p-[16px] items-center justify-center gap-[24px] rounded-[50px] bg-[#181818]">
                            <button className='w-[33.33%] flex px-[8px] py-[6px] justify-center items-center gap-[4px] rounded-[1000px] bg-[#737373]'>
                                <img src={AltitudeIcon} alt="altitude icon" className="w-[20px] h-[20px]" />
                                <p className='text-[#FAFAFA] text-center text-[16px] not-italic font-bold leading-[normal] tracking-[-0.32px]'>XP Hunter</p>
                            </button>
                        </div>
                    </div>
                    {loading ?
                        <div className="w-full flex justify-center">
                            <p className="text-[#000] text-[24px]">Loading...</p>
                        </div>
                        :
                        <div className='w-[60%] flex flex-col items-start gap-[8px]'>
                            {leaderBoardData.map((leaderBoard, index) => (
                                <div className='w-full flex justify-between p-[24px] gap-[24px]' key={index} style={getStyleBg(index)} >
                                    <div className='flex gap-[24px]'>
                                        <div className='flex w-[32px] h-[32px] justify-center items-center gap-[10px] rounded-[200px]' style={getStyleColor(index)} >
                                            <p className='text-[22.423px] not-italic font-bold leading-[16.194px] tracking-[-1.345px]' style={{ color: getTextColor(index) }}>{index + 1}</p>
                                        </div>
                                        <img src={leaderBoard.avatar_url ? `${Bucket_url}${leaderBoard.avatar_url}` : ProfilePic} alt="profile pic" className="w-[32px] h-[32px] rounded-[50%]" />
                                        <div className='flex flex-col items-start gap-[8px]'>
                                            <div className='flex items-center gap-[8px]'>
                                                <div className='flex h-[20px] px-[4px] py-0 justify-center items-center gap-[4px] rounded-[4px] bg-[#000]'>
                                                    <img src={RankingMeter} alt="ranking meter" className="w-[38px] h-[14.092px]" />
                                                </div>
                                                <p className='text-[#000] text-[20px] not-italic font-medium leading-[25px] tracking-[-0.8px]'>{leaderBoard.username}</p>
                                            </div>
                                            <p className='text-[#737373] text-[18px] not-italic font-medium leading-[28px] tracking-[-0.72px]'>{leaderBoard.missions_completed} missions</p>
                                        </div>
                                    </div>
                                    <p className='text-[#000] text-[20px] not-italic font-medium leading-[25px] tracking-[-0.8px]'>{leaderBoard.experience_points ? leaderBoard.experience_points : '0'} XP</p>
                                </div>
                            ))}
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default LeaderBoard;
